import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getRecentViewedCars, getWhatIsMyBusiness } from '../../Redux/Actions/UserAction';
import Sidebar from '../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { getSettingsSidebarOptions } from './sidebarOptions';

export default function RecentlyViewedCar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRecentViewedCars());
    dispatch(getWhatIsMyBusiness());
  }, [dispatch]);

  const recentViewedCarList = useSelector(
    (state) => state.home.recentViewedCars
  );
  const isLoading = useSelector((state) => state.loader?.isLoading);
  const getMybusiness = useSelector((state) => state.home?.getMybusiness);

  const sideBarOpt = getSettingsSidebarOptions(t, getMybusiness);

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-4">{t('Settings')}</h2>

          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} showPackage={false} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h5 key={Math.random()} class="mb-4">
                {t('Recently Viewed Cars')}
              </h5>

              <div class="row">
                {recentViewedCarList?.length > 0 ? (
                  recentViewedCarList?.map((item) => {
                    const type = item?.type;
                    const car = item?.car || item?.rentalCar;
                    const mainImage = car?.carMedia?.find(
                      (media) =>
                        media?.mediaType === 'MAIN_BANNER' ||
                        media?.mediaType === 'CAR_IMAGES'
                    )?.media?.path;

                    switch (type) {
                      case 'CAR03':
                        return (
                          <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-4">
                            <Link
                              to={`/user-car-dealers-details-in/${car?.carId}`}
                            >
                              <div class="set-rec-viewed-cars">
                                <div class="line-a">
                                  <img
                                    src={
                                      mainImage ||
                                      'assets/images/service-provider/car-sale/car.jpg'
                                    }
                                    alt=""
                                    class="img-fluid"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        'assets/images/service-provider/car-sale/car.jpg';
                                    }}
                                  />
                                </div>
                                <div class="line-b">
                                  <span>{car?.carName}</span> - {car?.carModel}
                                </div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>KD {car?.price}</span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.kilometerDriven} KM
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      case 'CAR04':
                        return (
                          <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-4">
                            <Link
                              to={`/user-rent-car-details-in/${item?.carRentalId}`}
                            >
                              <div class="set-rec-viewed-cars">
                                <div class="line-a">
                                  <img
                                    src={
                                      mainImage ||
                                      'assets/images/service-provider/car-sale/car.jpg'
                                    }
                                    alt=""
                                    class="img-fluid"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        'assets/images/service-provider/car-sale/car.jpg';
                                    }}
                                  />
                                </div>
                                <div class="line-b">
                                  <span>{car?.carName}</span> - {car?.carModel}
                                </div>
                                <div class="line-c">
                                  <div class="row justify-content-between">
                                    <div class="col-auto">
                                      <span>
                                        {t('Starting From')}{' '}
                                        {car?.packages[0]?.currency?.toUpperCase()}{' '}
                                        {car?.packages[0]?.starting_price}
                                      </span>
                                    </div>
                                    <div class="col-auto">
                                      {car?.packages[0]?.time}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      default:
                        return null;
                    }
                  })
                ) : (
                  <h6>{isLoading ? t('Loading...') : t('No Cars Found')}</h6>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
